import { Route } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import PaymentPage from "../pages/public/payment/PaymentPage";
import PaymentSuccessPage from "../pages/public/payment/PaymentSuccessPage";
import ChoosePlanPage from "../pages/public/post-property/ChoosePlanPage";
import PostSuccessPage from "../pages/public/post-property/PostSuccessPage";
import Interior from "../pages/public/Interior";

const ClientProtectedRoutes = [
  <Route key="client" path="/" element={<PublicLayout />}>
    <Route path="choose-plan" element={<ChoosePlanPage />} />
    <Route path="post-success" element={<PostSuccessPage />} />
    <Route path="payment">
      <Route index element={<PaymentPage />} />
      <Route path="success" element={<PaymentSuccessPage />} />
      <Route path="failed" element={<PaymentSuccessPage />} />
      {/* will add failed page later */}
    </Route>
    <Route path="interior" element={<Interior />} />
  </Route>,
];

export default ClientProtectedRoutes;
